import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-festival',
    templateUrl: './common-festival.component.html',
    styleUrls: ['./common-festival.component.scss'],
    standalone: false
})
export class CommonFestivalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
